#import "../fragments/calendar-fragment.graphql"

mutation RemoveConflictCalendar($calendarId: String!) {
    conflictCalendarRemove(calendarId: $calendarId) {
        calendars {
            ...CalendarFragment
        }
    }
}
